import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class U extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);

		if (data) {
			this.data = {nbTableBaseU: parseFloat(data.nb), nbTableU: parseFloat(data.n), isEcranMural: (data.em == "true")};
		}
		else {
			if (this.roomName == "1_3") {
				this.data = {nbTableBaseU: 3, nbTableU: 5, isEcranMural: false};
			}
			else {
				this.data = {nbTableBaseU: 2, nbTableU: 3, isEcranMural: false};
			}
		}

		this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName + "_T");
		if (!(this.grandEcranObject)) {
			this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName);
		}
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);

		this.listURoom = ["1", "3", "4", "5", "6", "7", "8", "9", "10", "11"];

	}

	Show() {
		if (!this.listURoom.includes(this.roomConfig)) {
			return;
		}
		else if (!this.refTable) {
			this.CreateTable();
		}
		else if(!this.refGrandEcran) {
			this.CreateGrandEcran();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var maxValue = {maxBase: 0, maxLong: 0};
			switch(this.roomConfig) {
				case "1":
					maxValue.maxBase = 5;
					maxValue.maxLong = 8;
					break;
				case "3":
					maxValue.maxBase = 5;
					maxValue.maxLong = 7;
					break;
				case "4":
				case "11":
					maxValue.maxBase = 2;
					maxValue.maxLong = 3;
					break;
				case "5":
				case "10":
					maxValue.maxBase = 4;
					maxValue.maxLong = 4;
					break;
				case "6":
				case "9":
					maxValue.maxBase = 4;
					maxValue.maxLong = 8;
					break;
				case "7":
				case "8":
					maxValue.maxBase = 4;
					maxValue.maxLong = 12;
					break;
			}
			this.data.nbTableBaseU = this.data.nbTableBaseU > maxValue.maxBase ? maxValue.maxBase : this.data.nbTableBaseU;
			this.data.nbTableU = this.data.nbTableU > maxValue.maxLong ? maxValue.maxLong : this.data.nbTableU;

			var currentTable = [];
			var currentGrandEcran = [];
			var currentPlafonnier = [];
			var currentSortieSecours = [];

			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Classe") {
					currentTable.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = true;
					this.whereToAddObjects.children[i].simsData.id = currentGrandEcran.length;
				}
				if (this.whereToAddObjects.children[i].name == "Grand_Ecran") {
					currentGrandEcran.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentGrandEcran.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}
			}

			var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
			if (plafonnierPos) {
				if (currentPlafonnier.length >= 1) {
					this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
					if (this.data.isEcranMural) {
						currentPlafonnier[0].visible = true;
					}
				}
				else {
					this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}

			var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
			var zoneDelimData = this.SetupDelimData(delim);
			if (zoneDelimData.length > 1) {
				zoneDelimData = zoneDelimData[0];
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			var tableCount = 1;
			var nextTable;
			var spaceBetweenTable = 1.4;
			var countAdded = 1;
			var currentNbTable = 0;
			var profTable = 0.7;

			var tablePlaceData = {posXPair:"", posXImpair:"", posZPair:"", posZImpair:"", resetRotY:"", baseRotY:"", longRotY:""};
			var centerX;
			switch (this.roomConfig) {
				case "1":
				case "3":
					zoneDelimData.minZ+=2;
					zoneDelimData.maxZ-=2;
					centerX = zoneDelimData.minX + ((zoneDelimData.maxX - zoneDelimData.minX) / 2);

					tablePlaceData.posXPair = centerX;
					tablePlaceData.posXImpair = centerX;
					tablePlaceData.posZPair = zoneDelimData.maxZ;
					tablePlaceData.posZImpair = zoneDelimData.maxZ;
					tablePlaceData.resetRotY = Math.PI * 2;
					tablePlaceData.baseRotY = Math.PI;
					tablePlaceData.longRotY = Math.PI/2;
					break;
				case "4":
				case "8":
				case "9":
				case "10":
					zoneDelimData.minZ+=1.5;
					zoneDelimData.maxZ-=1;
					centerX = zoneDelimData.minX + ((zoneDelimData.maxX - zoneDelimData.minX) / 2);

					tablePlaceData.posXPair = centerX - (spaceBetweenTable / 2);
					tablePlaceData.posXImpair = centerX;
					tablePlaceData.posZPair = zoneDelimData.minZ;
					tablePlaceData.posZImpair = zoneDelimData.minZ;
					tablePlaceData.resetRotY = Math.PI * 2;
					tablePlaceData.baseRotY = Math.PI * 2;
					tablePlaceData.longRotY = -Math.PI/2;
					break;
				case "5":
				case "6":
				case "7":
					centerX = zoneDelimData.minZ + ((zoneDelimData.maxZ - zoneDelimData.minZ) / 2);
					var tempZoneDelim = structuredClone(zoneDelimData);
					zoneDelimData.minZ = tempZoneDelim.minX + 1.5;
					zoneDelimData.maxZ = tempZoneDelim.maxX - 1;
					zoneDelimData.minX = tempZoneDelim.minZ;
					zoneDelimData.minZ = tempZoneDelim.minX;

					tablePlaceData.posXPair = zoneDelimData.minZ;
					tablePlaceData.posXImpair = zoneDelimData.minZ;
					tablePlaceData.posZPair = centerX + (spaceBetweenTable / 2);
					tablePlaceData.posZImpair = centerX;
					tablePlaceData.resetRotY = Math.PI/2;
					tablePlaceData.baseRotY = Math.PI/2;
					tablePlaceData.longRotY = Math.PI * 2;
					break;
				case "11":
					centerX = zoneDelimData.minZ + ((zoneDelimData.maxZ - zoneDelimData.minZ) / 2);
					var tempZoneDelim = structuredClone(zoneDelimData);
					zoneDelimData.minZ = tempZoneDelim.minX + 1.5;
					zoneDelimData.maxZ = tempZoneDelim.maxX - 2;
					zoneDelimData.minX = tempZoneDelim.minZ;
					zoneDelimData.minZ = tempZoneDelim.minX;

					tablePlaceData.posXPair = zoneDelimData.maxZ;
					tablePlaceData.posXImpair = zoneDelimData.maxZ;
					tablePlaceData.posZPair = centerX - (spaceBetweenTable / 2);
					tablePlaceData.posZImpair = centerX;
					tablePlaceData.resetRotY = -Math.PI/2;
					tablePlaceData.baseRotY = -Math.PI/2;
					tablePlaceData.longRotY = Math.PI;
			}

			
			if (this.data.nbTableBaseU % 2) {
				for (var i = 0; i < currentTable.length; i++) {
					currentTable[i].position.x = tablePlaceData.posXImpair;
					currentTable[i].position.z = tablePlaceData.posZImpair;
					currentTable[i].rotation.y = tablePlaceData.resetRotY;
				}
				this.refTable.rotation.y = tablePlaceData.baseRotY;
				currentNbTable++;

				while (tableCount < this.data.nbTableBaseU) {
					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((countAdded * spaceBetweenTable));
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 1;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((countAdded * spaceBetweenTable));
					}
					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((countAdded * spaceBetweenTable) * -1);
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 2;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((countAdded * spaceBetweenTable) * -1);
					}
					countAdded++;
					tableCount+=2;
				}

				for(var i = 0; i < this.data.nbTableU; i++) {
					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX(((countAdded - 1) * spaceBetweenTable) + (profTable / 2));
						currentTable[currentNbTable].translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						currentTable[currentNbTable].rotation.y = tablePlaceData.longRotY;
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 1;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX(((countAdded - 1) * spaceBetweenTable) + (profTable / 2));
						nextTable.translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						nextTable.rotation.y = tablePlaceData.longRotY;
					}

					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((((countAdded - 1) * spaceBetweenTable) + (profTable / 2)) * -1);
						currentTable[currentNbTable].translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						currentTable[currentNbTable].rotation.y = tablePlaceData.longRotY + Math.PI;
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 2;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((((countAdded - 1) * spaceBetweenTable) + (profTable / 2)) * -1);
						nextTable.translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						nextTable.rotation.y = tablePlaceData.longRotY + Math.PI;
					}
					tableCount+=2;
				}
			}
			else {
				for (var i = 0; i < currentTable.length; i++) {
					currentTable[i].position.x = tablePlaceData.posXPair;
					currentTable[i].position.z = tablePlaceData.posZPair;
					currentTable[i].rotation.y = tablePlaceData.resetRotY;
				}
				this.refTable.rotation.y = tablePlaceData.baseRotY;
				currentNbTable++;
				
				if (currentNbTable < currentTable.length) {
					currentTable[currentNbTable].translateX(spaceBetweenTable);
					currentNbTable++;
				}
				else {
					nextTable = this.refTable.clone();
					if (this.refTable.simsData) {
						nextTable.simsData = structuredClone(this.refTable.simsData)
						nextTable.simsData.id = tableCount + 1;
					}
					this.whereToAddObjects.add(nextTable);
					nextTable.translateX(spaceBetweenTable);
				}

				tableCount++;

				while (tableCount < this.data.nbTableBaseU) {
					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX(((countAdded + 1) * spaceBetweenTable));
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 1;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX(((countAdded + 1) * spaceBetweenTable));
					}

					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((countAdded * spaceBetweenTable) * -1);
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 2;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((countAdded * spaceBetweenTable) * -1);
					}

					countAdded++;
					tableCount+=2;
				}

				for(var i = 0; i < this.data.nbTableU; i++) {
					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((countAdded * spaceBetweenTable) + (profTable / 2));
						currentTable[currentNbTable].translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						currentTable[currentNbTable].rotation.y = tablePlaceData.longRotY;
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 1;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((countAdded * spaceBetweenTable) + (profTable / 2));
						nextTable.translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						nextTable.rotation.y = tablePlaceData.longRotY;
						currentNbTable++;
					}

					if (currentNbTable < currentTable.length) {
						currentTable[currentNbTable].translateX((((countAdded - 1) * spaceBetweenTable) + (profTable / 2)) * -1);
						currentTable[currentNbTable].translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						currentTable[currentNbTable].rotation.y = tablePlaceData.longRotY + Math.PI;
						currentNbTable++;
					}
					else {
						nextTable = this.refTable.clone();
						if (this.refTable.simsData) {
							nextTable.simsData = structuredClone(this.refTable.simsData);
							nextTable.simsData.id = tableCount + 2;
						}
						this.whereToAddObjects.add(nextTable);
						nextTable.translateX((((countAdded - 1) * spaceBetweenTable) + (profTable / 2)) * -1);
						nextTable.translateZ((spaceBetweenTable * (i+1)) - (profTable / 2));
						nextTable.rotation.y = tablePlaceData.longRotY + Math.PI;
					}
					tableCount+=2;
				}
			}


			var newPos;
			switch (this.roomConfig) {
				case "1":
				case "3":
					newPos = {posX : this.data.nbTableBaseU % 2?centerX:centerX - (spaceBetweenTable / 2), 
						posZ : this.refTable.position.z - (spaceBetweenTable * this.data.nbTableU + 2) };
					break;
				case "4":
				case "8":
				case "9":
				case "10":
					newPos = {posX : centerX, 
						posZ : this.refTable.position.z + (spaceBetweenTable * this.data.nbTableU + 1.5),
						rotY : Math.PI};
					break;
				case "5":
				case "6":
				case "7":
					newPos = {posZ : centerX, 
					posX : this.refTable.position.x + (spaceBetweenTable * this.data.nbTableU + 1.5),
					rotY : -Math.PI/2};
					break;
				case "11":
					newPos = {posZ : centerX, 
					posX : this.refTable.position.x - (spaceBetweenTable * this.data.nbTableU + 1.5),
					rotY : Math.PI/2};
					break;
			}

			if (currentGrandEcran.length) {
				this.objectGenerator.ApplyTransform(currentGrandEcran[0], newPos);
				currentGrandEcran[0].visible = true;
			}

			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
			if (currentTable.length > currentNbTable) {
				this.HideObjectAdded(currentTable, currentNbTable);
			}
		}
		this.data.type = "U";
		this.data.currentNbTable = tableCount;
	}

	Modify(value) {
		if (value.type == "nbTableBaseU") {
			this.data.nbTableBaseU = parseInt(value.value);
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		else if (value.type == "nbTableU") {
			this.data.nbTableU = parseInt(value.value);
		}
		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
	}


	CreateTable() {
		this.refTable = this.whereToAddObjects.getObjectByName("Classe");
		if (this.refTable) {
			this.refTable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateTable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Classe", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePraticable() {
		this.refPraticable = this.whereToAddObjects.getObjectByName("Praticable");
		if (this.refPraticable) {
			this.refPraticable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePraticable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Praticable", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateGrandEcran() {
		this.refGrandEcran = this.whereToAddObjects.getObjectByName("Grand_Ecran");
		if (this.refGrandEcran) {
			this.refGrandEcran.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateGrandEcran();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Grand_Ecran", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	ResetBaseConfig() {
		this.data = {nbTableBaseU: 3, nbTableU: 5};
	}
}